import { NgOptimizedImage } from '@angular/common';
import {
	ChangeDetectionStrategy,
	Component,
	computed,
	input,
	OnInit,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { CdnPathPipe, UniPipe } from '@uc/utilities';
import { ImpressionDirective, UniversityGAService } from '@uc/web/analytics';
import { RecommendedUniversity } from '@uc/web/shared/data-models';
import { BookmarkComponent } from '@uc/web/shared/features/feature-bookmark';
import { RecommendedVisitWebsiteBtnComponent } from '../../components/recommended-visit-website-btn/recommended-visit-website-btn.component';
import { RequestBtnComponent, WriteReviewBtnComponent } from '@uc/web/shared/buttons';
import { Product, ProductEnum } from '@uc/shared/data-models';

@Component({
	selector: 'uc-recommended-uni-card-xs',
	templateUrl: './recommended-uni-card-xs.component.html',
	imports: [
		RouterLink,
		NgOptimizedImage,
		ImpressionDirective,
		CdnPathPipe,
		UniPipe,
		BookmarkComponent,
		WriteReviewBtnComponent,
		RequestBtnComponent,
		RecommendedVisitWebsiteBtnComponent,
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecommendedUniCardXsComponent implements OnInit {
	uni = input.required<RecommendedUniversity>();
	componentName = input.required<string>();
	product = input.required<Product>();
	redirectUrl = '';

	isClearing = computed(() => this.product() === ProductEnum.Clearing);

	constructor(private _uniGASrv: UniversityGAService) {}

	ngOnInit(): void {
		if (this.product() === ProductEnum.Postgraduate) {
			this.redirectUrl = `/universities/${this.uni().slug}/postgraduate`;
		} else if (this.product() === ProductEnum.Clearing) {
			this.redirectUrl = `/universities/${this.uni().slug}/clearing`;
		} else {
			this.redirectUrl = `/universities/${this.uni().slug}`;
		}
	}

	onUniImpression(impression: any) {
		const ugso = !this.isClearing() ? this.uni().order : null;
		const cleso = this.isClearing() ? this.uni().order : null;

		if (impression) {
			this._uniGASrv.uniImpression(
				this.uni().id,
				this.uni().name,
				ugso,
				cleso,
				this.product(),
			);
		}
	}

	onUniClick() {
		const ugso = !this.isClearing() ? this.uni().order : null;
		const cleso = this.isClearing() ? this.uni().order : null;

		this._uniGASrv.uniProfileClick(
			this.uni().id,
			this.uni().name,
			ugso,
			cleso,
			this.product(),
		);
	}
}
